export type { FrontEndFlag } from './featureFlagList';

export { flagService } from './flagService';
